export var ColorFormat;
(function (ColorFormat) {
    ColorFormat["hex"] = "hex";
    ColorFormat["rgb"] = "rgb";
    ColorFormat["hsb"] = "hsb";
})(ColorFormat || (ColorFormat = {}));
